<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteToQuoteConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(:disabled="additional" autofocus url="customers" :label='$t("projects.customer_id")' disable-match :danger="$v.newRecord.customer.$invalid && $v.newRecord.customer.$model" :danger-text="$t('validation.required', { attribute: $t('projects.customer') })" :serializer="item => item.name" required :data="toQuotesCatalog.customers" :placeholder='$t("projects.customer_id_placeholder")' v-model="newRecord.customer" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc" :default-value="additional && newRecord.customer || quote && newRecord.customer ? newRecord.customer.name : null")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("projects.project_name_placeholder")' :danger="$v.newRecord.project_name.$invalid && $v.newRecord.project_name.$model" :danger-text="$t('validation.required', { attribute: $t('projects.project_name') })" v-model="newRecord.project_name" :label='$t("projects.project_name")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:disabled="additional" :placeholder='$t("projects.location_placeholder")' :danger="$v.newRecord.location.$invalid && $v.newRecord.location.$model" :danger-text="$t('validation.required', { attribute: $t('projects.location') })" v-model="newRecord.location" :label='$t("projects.location")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(:disabled="quote" style="width: 100%" :label='$t("projects.project_created_on")' :danger="$v.newRecord.project_created_on.$invalid && $v.newRecord.project_created_on.$model" :danger-text="$t('validation.required', { attribute: $t('projects.project_created_on') })" v-model="newRecord.project_created_on")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(:disabled="quote" style="width: 100%" :label='$t("projects.quotation_delivery_date")' :danger="!!$v.newRecord.quotation_delivery_date.$invalid && !!$v.newRecord.quotation_delivery_date.$model" :danger-text="$t('validation.required', { attribute: $t('projects.quotation_delivery_date') })" v-model="newRecord.quotation_delivery_date")
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ToQuotes')

export default {
  name: 'ModalToQuotes',
  props: {
    newRecord: {
      type: Object,
      default: null
    },
    additional: {
      type: Boolean,
      default: true
    },
    quote: {
      type: Boolean,
      default: true
    }
  },
  validations: {
    newRecord: {
      project_name: {
        required
      },
      location: {
        required
      },
      customer: {
        required
      },
      project_created_on: {
        required
      },
      quotation_delivery_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'toQuotesCatalog'
    ]),
    getTitle () {
      return this.additional ? this.$t('projects.additional') : this.$t('projects.add')
    }
  },
  methods: {
    ...mapActions([
      'addToQuote',
      'editToQuote',
      'deleteToQuote',
      'setModalVisible',
      'loadCatalog',
      'addToQuoteAdditional',
      'editQuote'
    ]),
    saveRecord () {
      if (this.additional) {
        this.addToQuoteAdditional(this.newRecord)
      } else if (this.quote) {
        this.editQuote(this.newRecord)
      } else {
        this.addToQuote(this.newRecord)
      }
    },
    async deleteToQuoteConfirm (toQuote) {
      let t = this
      this.auxDeleteToQuote = () => {
        t.deleteToQuote(toQuote)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(toQuote.id) }),
        accept: this.auxDeleteToQuote
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
